import React from 'react';
import { IplpTemplatesWhereInput } from '../../../../../graphql/graphql';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { useAppContext } from '../../../../../Services/AppContext';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';
// @ts-ignore
import styles from './IPLPTemplateListFilter.module.scss';

interface Props {
	onFilter: (filter: IplpTemplatesWhereInput) => void;
}

interface FilterFormValues {
	fulltext: string;
}

const IPLPTemplateListFilter: React.FC<Props> = ({ onFilter }) => {
	const { workplaceId } = useAppContext();

	const onFilterData = (values: { fulltext: string }) => {
		onFilter({
			workplaceId,
			fulltext: values.fulltext,
		});
	};

	return (
		<GridFilter<FilterFormValues> onChange={onFilterData}>
			<GridFilterItem
				type={GridFilterItemType.FULLTEXT}
				customLabel='component.IPLPTemplateListFilter.fulltext'
				formControlClassName={styles.formControl}
				contentWidth={400}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default IPLPTemplateListFilter;
